import { render, staticRenderFns } from "./Spawns.vue?vue&type=template&id=7bbdcb50&"
import script from "./Spawns.vue?vue&type=script&lang=js&"
export * from "./Spawns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports